import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "nawadah_cart";
const VOUCHER_KEY = "nawadah_voucher";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant, qty = 1, unit = product.unit) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id && i.variant_label === variant.label && i.unit === unit);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          variant_label: variant.label,
          price: variant.price,
          unit,
          image: (product.images || [])[0] || "",
          category: product.category || "",
          qty,
        },
      ];
    });
  };

  const updateQty = (product_id, variant_label, unit, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.product_id === product_id && i.variant_label === variant_label && i.unit === unit))
        : prev.map((i) => (i.product_id === product_id && i.variant_label === variant_label && i.unit === unit ? { ...i, qty } : i))
    );
  };

  const remove = (product_id, variant_label, unit) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.variant_label === variant_label && i.unit === unit)));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  const [voucher, setVoucherState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(VOUCHER_KEY)) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (voucher) localStorage.setItem(VOUCHER_KEY, JSON.stringify(voucher));
    else localStorage.removeItem(VOUCHER_KEY);
  }, [voucher]);

  const setVoucher = (v) => setVoucherState(v);
  const clearVoucher = () => setVoucherState(null);

  return (
    <CartCtx.Provider value={{ items, add, updateQty, remove, clear, count, subtotal, voucher, setVoucher, clearVoucher }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
